import request, {postRequestWithNoToken, buyerUrl,
  Method
} from '../plugins/request'

export function getByPageWithHouseType (params) {
  return request({
    url: `${buyerUrl}/buyer/store/getByPageWithHouseType`,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'},
  });
}

export function getstoreList(params) {
  return request({
    url: `${buyerUrl}/buyer/store`,
    method: Method.GET,
    params,
  });
}

/**
 * 获取店铺列表
 * @param params
 */
export function getstoreListWithGoodType(params) {
  return request({
    url: `${buyerUrl}/buyer/store/getByPageWithGoodType`,
    method: Method.GET,
    params,
  });
}
export function getAllStoreWithHouseType(params) {
  return request({
    url: `${buyerUrl}/buyer/store/getAllStoreWithHouseType`,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'},
  });
}

/**
 * 获取店铺列表---类型-菜品
 * @param params
 */
export function getStoreListWithArticleType(params) {
  return request({
    url: `${buyerUrl}/buyer/store/getStoreListWithArticleType`,
    method: Method.GET,
    params,
  });
}


/**
 * 获取店铺基本信息
 * @param storeId
 */
export function getStoreBaseInfo(storeId) {
  return request({
    url: `${buyerUrl}/buyer/store/get/detail/${storeId}`,
    method: Method.GET,
    loading: false,
  });
}
/**
 * 获取店铺基本信息
 * @param code
 */
export function getStoreBaseInfo2(code) {
  return request({
    url: `${buyerUrl}/buyer/store/getDetailByLicenseNum/${code}`,
    method: Method.GET,
    loading: false,
  });
}


/**
 * 获取店铺分类
 * @param id
 */
export function getStoreCategory(id) {
  return request({
    url: `${buyerUrl}/buyer/store/label/get/${id}`,
    method: Method.GET,
  });
}

/**
 * 修改店铺信息
 * @param param
 */
export function editStore(params) {
  return request({
    url: `${buyerUrl}/buyer/store/edit`,
    method: Method.POST,
    needToken: true,
    message: false,
    data: params,
    headers: {'Content-Type': 'application/json'},
  });
}

/**
 * 营业执照
 * @param id
 */
export function getLicencePhoto(id) {
  return request({
    url: `${buyerUrl}/buyer/store/get/licencePhoto/${id}`,
    method: Method.GET,
  });
}

export function getStoreDetail() {
  return request({
    url: `/store/get/storeDetail`,
    method: Method.GET,
  });
}

/**
 * 申请民宿
 * @param store
 */
export function applyStore(params) {
  return request({
    url: `/store/apply/homestay`,
    method: Method.POST,
    needToken: true,
    header: { "content-type": "application/x-www-form-urlencoded" },
    data: params,
  });
}




/**
 * 获取当前店铺复查信息
 * @param storeId
 */
export function getStoreCheckById(id) {
  return request({
    url: `/store/check/getStoreCheckById/${id}`,
    method: Method.GET,
  });
}

/**
 * 获取当前店铺复查信息
 * @param storeId
 */
export function getStoreCheckByStoreIdAndExaminerId(storeId) {
  return request({
    url: `/store/check/getStoreCheckByStoreIdAndExaminerId/${storeId}`,
    method: Method.GET,
  });
}

/**
 * 获取当前店铺复查信息 item
 * @param checkId
 */
export function getStoreCheckItemByRecheckId(checkId) {
  return request({
    url: `/store/check/getStoreCheckItemByRecheckId/${checkId}`,
    method: Method.GET,
  });
}



/**
 * 新增店铺检查信息
 * @param checkId
 */
export function addCheck(params) {
  return request({
    url: '/store/check/addCheck',
    method: Method.POST,
    needToken: true,
    message: false,
    data:params,
    headers: {'Content-Type': 'application/json'},
  });
}













/**
 * 获取店铺列表 --吃在后营
 * @param params
 */
export function getByPageWithCaiPin(params) {
  return http.request({
    url: `/store/getByPageWithCaiPin`,
    method: Method.GET,
    params,
  });
}

/**
 * 获取店铺基本信息
 * @param storeId
 */
export function getStoreDetail2(storeId) {
  return http.request({
    url: `/store/get/detail2/${storeId}`,
    method: Method.GET,
    loading: false,
  });
}

/**
 * 获取店铺基本信息
 * @param storeId
 */
export function getStoreBaseInfoCaipin(storeId) {
  return http.request({
    url: `/store/get/detail2/${storeId}`,
    method: Method.GET,
    loading: false,
  });
}



// WEBPACK FOOTER //
// ./src/api/store.js